import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { register as registerSW, registerNetworkListener, registerInstallPrompt } from './utils/serviceWorker';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA functionality
if (import.meta.env.PROD) {
  registerSW({
    onSuccess: (registration) => {
      console.log('PWA: App is ready for offline use');
    },
    onUpdate: (registration) => {
      console.log('PWA: New version available');
      // You can show a notification to the user about the update
      if (window.confirm('Eine neue Version ist verfügbar. Seite neu laden?')) {
        if (registration.waiting) {
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        window.location.reload();
      }
    },
    onOffline: () => {
      console.log('PWA: App is running in offline mode');
    },
    onOnline: () => {
      console.log('PWA: App is back online');
    },
  });

  // Register network status listener
  registerNetworkListener();

  // Register PWA install prompt
  registerInstallPrompt();
}